import { render, staticRenderFns } from "./ChatHistory.vue?vue&type=template&id=1d2ebbc3&scoped=true"
import script from "./ChatHistory.vue?vue&type=script&lang=js"
export * from "./ChatHistory.vue?vue&type=script&lang=js"
import style0 from "./ChatHistory.vue?vue&type=style&index=0&id=1d2ebbc3&prod&lang=css"
import style1 from "./ChatHistory.vue?vue&type=style&index=1&id=1d2ebbc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ebbc3",
  null
  
)

export default component.exports